// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiGitlab as RawSiGitlab } from "react-icons/si";
export const SiGitlab = /* @__PURE__ */ createIcon(RawSiGitlab, "SiGitlab", 0);
